import capitalize from '@utils/capitalize'

const RegisteredType = ({ user, capitalizeEach }) => {
  let registeredType = 'anonymous'
  if (user && !user?.isAnonymous) registeredType = 'registered'
  if (user && user?.isSubscribed) registeredType = 'subscribed'
  registeredType = registeredType + ' user'
  return capitalizeEach ? capitalize(registeredType) : registeredType
}

const RegisteredIndicator = ({ user, size='1rem', style }) => {
  let iconType = 'mask'
  if (user && !user?.isAnonymous) iconType = 'person'
  if (user && user?.isSubscribed) iconType = 'subscribed'
  return (
    <img
      src={`https://mandrake-app.b-cdn.net/dev/application/icons/${iconType}.svg`}
      style={{
        height: size,
        width: size,
        ...style,
      }}
    />
  )
}

export default RegisteredIndicator

export { RegisteredType }
